import React from "react";

export const Steps = () => {
  return (
    <>
      {/* <section className="mt-40">
        <div>
          <div className="-mx-4 flex ">
            <div className="w-full px-4 mx-10 md:mx-[15%]">
              <div className="mx-auto mb-[60px]  text-center lg:mb-20">
                <span className="text-transparent text-sm md:text-lg bg-clip-text bg-gradient-to-b from-[#AFA4FF] to-[#D19CFF]">
                  Start Now!
                </span>
                <h2 className="mb-4 text-3xl font-bold text-dark dark:text-white sm:text-[40px]/[48px]">
                  How To Get Started For Free
                </h2>
                <p className="text-base text-body-color dark:text-dark-6">
                  Getting started with our AI Calling agents is quick and
                  effortless. Simply sign up, and youll gain access to a
                  powerful tool that transforms customer engagement. With no
                  upfront costs, you can explore how our AI-driven technology
                  streamlines communication, enhances efficiency, and elevates
                  customer satisfaction. Experience personalized, 24/7
                  assistance tailored to your business needs, all without any
                  financial commitment. Let us help you revolutionize the way
                  you interact with your customers start your journey for free
                  today!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="p-4 max-w-6xl mx-auto">
            <div className="flex">
              <div className="mr-4 flex flex-col items-center">
                <div>
                  <div className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-[#7E35FB]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="h-6 w-6 text-[#7E35FB]"
                    >
                      <path d="M12 5l0 14"></path>
                      <path d="M18 13l-6 6"></path>
                      <path d="M6 13l6 6"></path>
                    </svg>
                  </div>
                </div>
                <div className="h-full w-px bg-[#7E35FB]"></div>
              </div>
              <div className="pt-1 pb-8">
                <p className="mb-2 text-xl font-bold text-[#B48EF5]">
                  Receive a live call from the AI agent and experience it
                  firsthand.
                </p>
                <p className="text-white text-sm">
                  Experience the power of AI firsthand by receiving a live call
                  from our intelligent AI agent. Engage in a dynamic
                  conversation as the AI demonstrates its capabilities in
                  understanding, responding, and assisting with your queries.
                  Whether it's answering your questions, providing
                  recommendations, or guiding you through a task, this live call
                  will showcase the seamless interaction and efficiency of our
                  AI technology. Take this opportunity to explore how the future
                  of communication feels today!
                </p>
              </div>
            </div>

            <div className="flex">
              <div className="mr-4 flex flex-col items-center">
                <div>
                  <div className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-[#7E35FB]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="h-6 w-6 text-[#7E35FB]"
                    >
                      <path d="M12 5l0 14"></path>
                      <path d="M18 13l-6 6"></path>
                      <path d="M6 13l6 6"></path>
                    </svg>
                  </div>
                </div>
                <div className="h-full w-px bg-[#7E35FB]"></div>
              </div>
              <div className="pt-1 pb-8">
                <p className="mb-2 text-xl font-bold text-[#B48EF5]">
                  Book a call with our team via the AI agent or by clicking the
                  'Get Started' link.
                </p>
                <p className="text-white text-sm">
                  Easily schedule a call with our expert team by utilizing the
                  convenience of our AI agent or simply clicking the 'Get
                  Started' link. Whether you prefer the interactive assistance
                  of our advanced AI or the straightforward process of booking
                  online, we’ve made it simple and seamless for you to connect
                  with us. Our team is here to provide personalized guidance,
                  answer your questions, and ensure you have all the information
                  you need. Don’t miss the chance to explore our services—book
                  your call today and take the first step toward achieving your
                  goals!
                </p>
              </div>
            </div>

            <div className="flex">
              <div className="mr-4 flex flex-col items-center">
                <div>
                  <div className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-[#7E35FB]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="h-6 w-6 text-[#7E35FB]"
                    >
                      <path d="M12 5l0 14"></path>
                      <path d="M18 13l-6 6"></path>
                      <path d="M6 13l6 6"></path>
                    </svg>
                  </div>
                </div>
                <div className="h-full w-px bg-[#7E35FB]"></div>
              </div>
              <div className="pt-1 pb-8">
                <p className="mb-2 text-xl font-bold text-[#B48EF5]">
                  Answer a few questions, and we'll create a personalized AI
                  agent for your business.
                </p>
                <p className="text-white text-sm">
                  Take the first step toward transforming your business with a
                  custom AI solution tailored to your needs. Simply answer a few
                  questions about your business, goals, and the challenges
                  you’re looking to solve, and we’ll craft a personalized AI
                  agent designed specifically for your operations. Whether it’s
                  streamlining customer service, enhancing lead generation, or
                  automating routine tasks, your AI agent will be equipped to
                  handle it all. Let us help you unlock the potential of AI to
                  drive efficiency, improve customer experiences, and give your
                  business a competitive edge. Start building your personalized
                  AI agent today!
                </p>
              </div>
            </div>

            <div className="flex">
              <div className="mr-4 flex flex-col items-center">
                <div>
                  <div className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-[#7E35FB] bg-[#7E35FB]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="h-6 w-6 text-white"
                    >
                      <path d="M5 12l5 5l10 -10"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div className="pt-1">
                <p className="mb-2 text-xl font-bold text-[#B48EF5]">
                  Integrate with your CRM and existing systems.
                </p>
                <p className="text-white text-sm">
                  Seamlessly integrate our AI-powered solution with your CRM and
                  existing systems to streamline your operations like never
                  before. Our technology is designed to work effortlessly with
                  the tools you already use, ensuring a smooth and hassle-free
                  setup. Whether you’re using popular platforms or custom-built
                  software, our solution adapts to your workflows, enhancing
                  productivity and minimizing disruptions. By connecting your
                  CRM and other systems, you can centralize data, automate
                  repetitive tasks, and provide a unified experience for your
                  team and customers. Unlock the full potential of your existing
                  infrastructure with an integration that simplifies processes
                  and drives results.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <section className="py-12">
        {" "}
        {/* Container */}{" "}
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-center px-5 py-16 md:px-10 md:py-20">
          {" "}
          {/* HEADING TEXT */}{" "}
          <span className="text-transparent text-sm md:text-lg bg-clip-text bg-gradient-to-b from-[#AFA4FF] to-[#D19CFF]">
            Start Now!
          </span>
          <h2 className="mb-4 text-3xl text-center font-bold text-white sm:text-[40px]/[48px]">
            How To Get Started For Free
          </h2>
          <p className="text-base text-center text-gray-200">
            Getting started for free is simple and hassle-free! Just follow the
            steps below to begin your journey. Whether you're exploring for the
            first time or looking to test out all the amazing features, we've
            got you covered with an easy-to-follow guide.
          </p>
          {/* HOW IT WORKS STEPS */}{" "}
          <div className="flex flex-col items-center justify-center md:pl-20 lg:flex-row">
            {" "}
            {/* BLOCK */}{" "}
            <div className="relative my-8 flex w-full rounded-md  lg:flex-col">
              <div className="flex h-16 w-16 items-center justify-center rounded-md bg-[#7E35FB]">
                <h2 className="text-3xl font-medium text-white ">1</h2>
              </div>
              <div className="ml-6 lg:ml-0">
                <h2 className="mb-5 text-xl font-medium lg:mt-8 text-white">
                  {" "}
                  Phone Number
                </h2>
                <p className="font-inter max-w-md pr-5 text-base text-gray-300">
                 Enter your phone number in the form and initiate you call.
                </p>
              </div>{" "}
              {/* MOBILE - HOW IT WORKS LINE */}{" "}
              <svg
                className="absolute -bottom-[48px] left-[28px] lg:hidden"
                width="12"
                height="70"
                viewBox="0 0 12 95"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 0.226497L0.226497 6L6 11.7735L11.7735 6L6 0.226497ZM6 94.7735L11.7735 89L6 83.2265L0.226497 89L6 94.7735ZM5 6V10.15H7V6H5ZM5 18.45V26.75H7L7 18.45H5ZM5 35.05L5 43.35H7V35.05H5ZM5 51.65L5 59.95H7L7 51.65H5ZM5 68.25L5 76.55H7L7 68.25H5ZM5 84.85L5 89H7V84.85H5Z"
                  fill="#7E35FB"
                ></path>
              </svg>
              {/* DESKTOP - HOW IT WORKS LINE */}{" "}
              <svg
                className="absolute right-0 top-7 hidden lg:block"
                width="170"
                height="12"
                viewBox="0 0 170 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.226497 6L6 11.7735L11.7735 6L6 0.226497L0.226497 6ZM169.773 6L164 0.226497L158.227 6L164 11.7735L169.773 6ZM6 7H9.95V5H6V7ZM17.85 7H25.75V5H17.85V7ZM33.65 7H41.55V5H33.65V7ZM49.45 7H57.35V5H49.45V7ZM65.25 7H73.15V5H65.25V7ZM81.05 7H88.95V5H81.05V7ZM96.85 7H104.75V5H96.85V7ZM112.65 7H120.55V5H112.65V7ZM128.45 7H136.35V5H128.45V7ZM144.25 7H152.15V5H144.25V7ZM160.05 7H164V5H160.05V7Z"
                  fill="#7E35FB"
                />
              </svg>
            </div>{" "}
            {/* BLOCK */}{" "}
            <div className="relative my-8 flex w-full rounded-md lg:mx-8 lg:flex-col">
              <div className="flex h-16 w-16 items-center justify-center rounded-md bg-[#7E35FB]">
                <h2 className="text-3xl font-medium text-white ">2</h2>
              </div>
              <div className="ml-6 lg:ml-0">
                <h2 className="mb-5 text-xl font-medium lg:mt-8 text-white">
                  {" "}
                  Talk to agent
                </h2>
                <p className="font-inter max-w-md pr-5 text-base text-gray-300">
                  Talk to our AI agent and provide information about you.
                </p>
              </div>{" "}
              {/* MOBILE - HOW IT WORKS LINE */}{" "}
              <svg
                className="absolute -bottom-[48px] left-[28px] lg:hidden"
                width="12"
                height="70"
                viewBox="0 0 12 95"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 0.226497L0.226497 6L6 11.7735L11.7735 6L6 0.226497ZM6 94.7735L11.7735 89L6 83.2265L0.226497 89L6 94.7735ZM5 6V10.15H7V6H5ZM5 18.45V26.75H7L7 18.45H5ZM5 35.05L5 43.35H7V35.05H5ZM5 51.65L5 59.95H7L7 51.65H5ZM5 68.25L5 76.55H7L7 68.25H5ZM5 84.85L5 89H7V84.85H5Z"
                  fill="#7E35FB"
                ></path>
              </svg>{" "}
              {/* DESKTOP - HOW IT WORKS LINE */}{" "}
              <svg
                className="absolute right-0 top-7 hidden lg:block"
                width="170"
                height="12"
                viewBox="0 0 170 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.226497 6L6 11.7735L11.7735 6L6 0.226497L0.226497 6ZM169.773 6L164 0.226497L158.227 6L164 11.7735L169.773 6ZM6 7H9.95V5H6V7ZM17.85 7H25.75V5H17.85V7ZM33.65 7H41.55V5H33.65V7ZM49.45 7H57.35V5H49.45V7ZM65.25 7H73.15V5H65.25V7ZM81.05 7H88.95V5H81.05V7ZM96.85 7H104.75V5H96.85V7ZM112.65 7H120.55V5H112.65V7ZM128.45 7H136.35V5H128.45V7ZM144.25 7H152.15V5H144.25V7ZM160.05 7H164V5H160.05V7Z"
                  fill="#7E35FB"
                />
              </svg>
            </div>{" "}
            {/* BLOCK */}{" "}
            <div className="relative my-8 flex w-full rounded-md lg:mx-8 lg:flex-col">
              <div className="flex h-16 w-16 items-center justify-center rounded-md bg-[#7E35FB]">
                <h2 className="text-3xl font-medium text-white ">3</h2>
              </div>
              <div className="ml-6 lg:ml-0">
                <h2 className="mb-5 text-xl font-medium lg:mt-8 text-white">
                  Complete
                </h2>
                <p className="font-inter max-w-md pr-5 text-base text-gray-300">
                 Now after testing AI agent you are good to go.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
